export class BusLaneModel {
  id = '0';
  name = '';
  description = '';
  selectedTypeId = '0';
  location = '';
}
